import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface IConnectionStoreState {
    showConnectedSnackbarMessage: boolean;
    showRefreshSnackbarMessage: boolean;
    showReconnectingSnackbarMessage: boolean;
}

const initialState: IConnectionStoreState = {
    showConnectedSnackbarMessage: false,
    showReconnectingSnackbarMessage: false,
    showRefreshSnackbarMessage: false
};

const connectionSlice = createSlice({
    name: "connection",
    initialState,
    reducers: {
        hideAllSnackbarMessages(state) {
            state.showConnectedSnackbarMessage = false;
            state.showReconnectingSnackbarMessage = false;
            state.showRefreshSnackbarMessage = false;
        },
        setShowConnectedSnackbarMessage(state, action: PayloadAction<boolean>) {
            // If connected, hide all other messages
            if (action.payload === true) {
                state = initialState;
            }
            state.showConnectedSnackbarMessage = action.payload;
        },
        setShowReconnectingSnackbarMessage(
            state,
            action: PayloadAction<boolean>
        ) {
            state.showReconnectingSnackbarMessage = action.payload;
        },
        setShowRefreshSnackbarMessage(state, action: PayloadAction<boolean>) {
            state.showRefreshSnackbarMessage = action.payload;
        }
    }
});

export const {
    hideAllSnackbarMessages,
    setShowConnectedSnackbarMessage,
    setShowReconnectingSnackbarMessage,
    setShowRefreshSnackbarMessage
} = connectionSlice.actions;

export default connectionSlice.reducer;
